import { ActivityBasicInfo } from '@quickService/ActivitiesPublicRegistrationPage';
import { Button } from '@tencent/tea-component';
import '@tencent/tpm-meeting-active/lib/ScreeningList/style';
import { FC, useCallback, useContext } from 'react';
import CanvasCover1 from '@tencent/tpm-meeting-active/lib/CanvasCover1';
import CanvasCover2 from '@tencent/tpm-meeting-active/lib/CanvasCover2';
import '@tencent/tpm-meeting-active/lib/CanvasCover1/style';
import '@tencent/tpm-meeting-active/lib/CanvasCover2/style';
import './index.scss';
import useSignUp from '../../../utils/signUp';
import { TicketType } from '../../controller/getServerProps';
import { AppContext } from '@utils/browser/app-context';
import { goLogin } from '@utils/login-util';
import dataReport from '@utils/data-report';
import { MyScheduleIconContext } from '../../CanvasRender';

interface IRegisterButtonWithSessionSelect {
  /** 日程场次 */
  schedules: ActivityBasicInfo['schedules'];
  activityBasicInfo: ActivityBasicInfo;
  eventId: string;
  className?: string;
  /** 活动报名状态；0:暂未开售；1:报名终止；2:名额已满；3:立即报名 */
  eventStatus: number;
  /** 活动主题封面 */
  cover?: number;
  isMobile?: boolean;
  /** 按钮类型 */
  type?: 'default' | 'primary';
}
/** 场次选择 */
const RegisterButtonWithSessionSelect: FC<IRegisterButtonWithSessionSelect> = ({
  schedules,
  activityBasicInfo,
  className,
  eventId,
  eventStatus,
  cover = 1,
  isMobile = false,
  type,
}) => {
  const { userData } = useContext(AppContext);
  const { wxopenid } = useContext(MyScheduleIconContext);
  const signUp = useSignUp(undefined, wxopenid);
  const showSessionSelect = useCallback(() => {
    dataReport('e#event_registrationpage#registration_button#click', {
      event_state: eventStatus === 1 ? 2 : eventStatus,
      activity_id: eventId,
      registration_page_style: 1,
    });
    // 未登录用户跳转登录
    if (!userData.userid) {
      goLogin();
      return;
    }

    signUp(eventId, '', activityBasicInfo.ticket_type);
  }, [schedules, signUp, eventId, activityBasicInfo.ticket_type, userData.userid, eventStatus]);

  if (activityBasicInfo.access_rule === 1) {
    return null;
  }

  if (isMobile) {
    return (
      <Button onClick={showSessionSelect} className={className} disabled={eventStatus !== 3}>
        {getText(schedules, activityBasicInfo.ticket_type, eventStatus)}
      </Button>
    );
  }
  const WRAP = cover === 2 ? CanvasCover2.Btn : CanvasCover1.Btn;
  return (
    <WRAP
      text={getText(schedules, activityBasicInfo.ticket_type, eventStatus)}
      onClick={showSessionSelect}
      disabled={eventStatus !== 3}
      className={className}
      type={type}
    ></WRAP>
  );
};

const BtnTxt = ['暂未开售', '报名截止', '名额已满', '立即报名'];
const getText = (
  schedules: IRegisterButtonWithSessionSelect['schedules'],
  type: number,
  /** 活动报名状态；0:暂未开售；1:报名终止；2:名额已满；3:立即报名 */
  eventStatus: number,
) => {
  if (eventStatus !== 3) {
    return BtnTxt[eventStatus];
  }
  if (type === TicketType.PACKAGE) {
    // 要判断有无优惠
    return '立即报名';
  }
  return schedules.length > 1 ? '选场报名' : '立即报名';
};

export default RegisterButtonWithSessionSelect;
